/**
 * 固定ナビゲーション
 */

jQuery( function ($) {
  $('.c-fixed-nav li').each( function() {
    if($(this).hasClass('current_page_item')) {
      $(this).find('i').removeClass('ph-thin').addClass('ph-fill');
    } else {
      $(this).find('i').removeClass('ph-fill').addClass('ph-thin');
    }
  });
});
